import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import LongLat from "@mapmycustomers/shared/types/base/LongLat";
import PlatformBounds from "@mapmycustomers/shared/types/map/PlatformBounds";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { UniversalFieldName } from "@app/util/fieldModel/universalFieldsFieldModel";
import { getSimpleConditionForField } from "@app/util/filters/utils";

export type MapArea =
  | { kind: "near"; name: string }
  | { kind: "place"; name: string }
  | { kind: "this" };

export interface MapAreaOptions {
  bounds?: PlatformBounds;
  leadFinderCenter?: LongLat;
  leadFinderLocation?: string;
}

// West above east means the viewport crosses the antimeridian.
const isInBounds = (
  [lng, lat]: LongLat,
  { bottom_right: [east, south], top_left: [west, north] }: PlatformBounds
) =>
  lat >= south &&
  lat <= north &&
  (west <= east ? lng >= west && lng <= east : lng >= west || lng <= east);

// The place name the store already knows; the map never reverse-geocodes its viewport.
const getMapArea = (
  filter: MapFilterModel,
  { bounds, leadFinderCenter, leadFinderLocation }: MapAreaOptions = {}
): MapArea => {
  const condition = getSimpleConditionForField(filter.universal, UniversalFieldName.GEOPOINT);
  if (condition?.operator === FilterOperator.IN_AREA) {
    const name = condition.value?.location ?? condition.value?.entity?.name;
    if (name) {
      return { kind: "near", name };
    }
  }
  // Once the rep pans the search center out of view, the place name no longer describes the map.
  const searchInView = !leadFinderCenter || !bounds || isInBounds(leadFinderCenter, bounds);
  if (leadFinderLocation && searchInView) {
    return { kind: "place", name: leadFinderLocation };
  }
  return { kind: "this" };
};

export default getMapArea;
